import React, { ErrorInfo, ReactNode } from 'react'
import { ErrorPage } from './not_found'
import PropTypes from 'prop-types'

/**
 *  The state of the error boundary class component
 */
interface State {
  /** Flag to indicate if an error has occurred */
  hasError: boolean
  /** The error that has occurred */
  error?: Error
}
/**
 *  The props of the error boundary class component
 */
interface Props {
  /** The children to be rendered if no error has occurred */
  children: ReactNode
}

/**
 * ErrorBoundary class component to catch errors in the children components
 * and display a fallback UI.
 * @category Error
 */
export default class ErrorBoundary extends React.Component<Props, State> {
  public override state: State = { hasError: false }

  static getDerivedStateFromError(_error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  public static propTypes = {
    children: PropTypes.node.isRequired,
  }

  override componentDidCatch(error: Error, _errorInfo: ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error(error)
    this.setState({ hasError: true, error })
  }

  override render() {
    if (this.state.hasError) {
      return (
        <ErrorPage
          msg='Es ist ein Fehler aufgetreten. Bitte wende dich an unseren Support unter support@comstruct.com, wir helfen dir umgehend.'
          details={`${this.state.error?.message} - ${this.state.error?.stack}`}
        />
      )
    }

    return this.props.children
  }
}
